import React, { Component } from 'react';
import Hero from '../Hero';
import Authenticate from '../Authenticate';
import FeaturesBlock from '../FeaturesBlock';
import Secure from '../Secure';
import Manage from '../Manage';
import ManageDesktop from '../ManageDesktop';
import EmbeddedLock from '../EmbeddedLock';
import Auth0Banner from '../Auth0Banner';
import { UniversalLoginStyled } from './styled.js';

class UniversalLogin extends Component {
  render() {
    return (
      <UniversalLoginStyled>
        <Hero />
        <Authenticate />
        <FeaturesBlock />
        <Secure />
        <Manage />
        <ManageDesktop />
        <EmbeddedLock />
        <Auth0Banner />
      </UniversalLoginStyled>
    );
  }
}

export default UniversalLogin;



// WEBPACK FOOTER //
// ./src/pages/universal-login/components/UniversalLogin/UniversalLogin.js